<template>
  <div class="home_content">
    <div class="item" :style="{ borderRight: '3px solid #22c55e' }">
      <div class="itme_r">
        <div class="item_title">设备总数量</div>
        <div class="num text-black mt-1">{{ statsData.totalCount ?? '0' }}</div>
        <div class="subtext text-green-500 mt-2">↑ 正常运行</div>
      </div>
    </div>
    <div class="item" :style="{ borderRight: '3px solid #22c55e' }">
      <div class="itme_r">
        <div class="item_title">在线设备</div>
        <div class="num text-green-600 mt-1">{{ statsData.onlineCount ?? '0' }}</div>
        <div class="subtext text-gray-400 mt-2">在线率 {{ statsData.onlineRate ?? '0%' }}</div>
      </div>
    </div>
    <div class="item" :style="{ borderRight: '3px solid #f97316' }">
      <div class="itme_r">
        <div class="item_title">离线设备</div>
        <div class="num text-orange-500 mt-1">{{ statsData.offlineCount ?? '0' }}</div>
        <div class="subtext text-gray-400 mt-2">待排查</div>
      </div>
    </div>
    <div class="item" :style="{ borderRight: '3px solid #ef4444' }">
      <div class="itme_r">
        <div class="item_title">今日告警</div>
        <div class="num text-red-500 mt-1">{{ statsData.todayAlarmCount ?? '0' }}</div>
        <div class="subtext text-gray-400 mt-2">未处理</div>
      </div>
    </div>
    <div class="item" :style="{ borderRight: '3px solid #7e5bfd' }">
      <div class="itme_r">
        <div class="item_title">今日作业时长</div>
        <div class="num text-black mt-1">{{ statsData.todayWorkHours ?? '0' }}<span class="unit"> h</span></div>
        <div class="subtext text-gray-400 mt-2">累计开机时长</div>
      </div>
    </div>
    <div class="item">
      <div class="itme_r">
        <div class="item_title">今日施工面积</div>
        <div class="num text-black mt-1">{{ statsData.todayWorkArea ?? '0' }}<span class="unit"> ㎡</span></div>
        <div class="subtext text-gray-400 mt-2">累计作业面积</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { EquipmentLedgerHomeStats } from "@/api/equipmentLedger.js";

const statsData = ref({
  totalCount: 0,
  onlineCount: 0,
  offlineCount: 0,
  onlineRate: "0%",
  todayAlarmCount: 0,
  unhandledAlarmCount: 0,
  todayWorkHours: 0,
  todayWorkArea: 0
});

const getHomeStats = async () => {
  try {
    const res = await EquipmentLedgerHomeStats();
    if (res.code === 200 && res.data) {
      Object.assign(statsData.value, res.data);
    }
  } catch (error) {
    console.error("获取首页统计卡片数据失败:", error);
  }
};

onMounted(() => {
  getHomeStats();
});
</script>

<style lang="less" scoped>
.home_content {
  display: grid;
  justify-content: space-between;
  grid-template-columns: repeat(6, 1fr);
  gap: 15px;
}

.item {
  height: 110px;
  border-radius: 6px;
  box-sizing: border-box;
  background-color: #fff;
  display: flex;
  align-items: center;
  overflow: hidden;
  padding: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.num {
  font-size: 28px;
  font-weight: bold;
  line-height: 1.1;
}

.text-green-600 {
  color: #22c55e;
}
.text-green-500 {
  color: #22c55e;
}
.text-orange-500 {
  color: #f97316;
}
.text-red-500 {
  color: #ef4444;
}
.text-black {
  color: #1a1a1a;
}

.item_title {
  font-size: 13px;
  color: #666;
}

.subtext {
  font-size: 12px;
}

.unit {
  font-size: 14px;
  color: #888;
  font-weight: normal;
}

.itme_r {
  flex: 1;
}
</style>
